import React, { useEffect, useState, useRef } from 'react';
import styles from './projectSkeleton.module.scss';
function ProjectSkeleton(props: any) {

    useEffect(() => {
        return () => {
        }
    }, [])

    return (
        <div className={`${styles.homeProject_content}`}>
            <div className={`${styles.project}`}>
                <div className={`${styles.title}`}>
                    我的项目
                </div>
                <div className={`${styles.content}`}>
                    <div>
                        <div></div>
                    </div>
                    <div>
                        <div></div>
                    </div>
                    <div>
                        <div></div>
                    </div>
                    <div>
                        <div></div>
                    </div>
                    <div>
                        <div></div>
                    </div>
                    <div>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default ProjectSkeleton;